/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment } from "react";
import { Link } from "@reach/router";

import useLogin from "../providers/use_login";
import useAdminApi from "../hooks/use_admin_api";
import WikiNavBar from "../components/navbar";
import Login from "../components/login";
// import LogViewer from "../components/log_viewer";
import Footer from "../components/footer";
import Loading from "../components/loading";
import ListaPropuestas from "../components/lista-propuestas"
import ListaUsuariosInactivos from "../components/lista-usuarios-inactivos"

const AdminPage = () => {
  const { token, user, isReady, logout } = useLogin();
  const { propuestas, inactivos, reFetch, isBusy, isBusyTask, aprobarUsuario, borrarUsuario, } = useAdminApi();

  if (!isReady) return <Fragment>
    <WikiNavBar />
    <Loading />
  </Fragment>

  if (!token)
    return (
      <Fragment>
        <WikiNavBar />
        <div style={{ marginTop: 55 }} />
        <Login />
      </Fragment>
    );

  if (user && user.role === 'admin') return (
    <Fragment>
      <WikiNavBar />
      <div className="container">
        <div style={{ height: 20 }} />
        <h2>Panel de Administración</h2>
        <p>
          Sesión iniciada como: {user.displayName} (
          <Link onClick={logout} to="/">
            Salir
          </Link>
          )
        </p>
        {token ? (
          <Fragment>
            <div className="row">
              <div className="col-sm">
                <h3>Propuestas pendientes de revisión:</h3>
                {isBusy ? <Loading /> : <ListaPropuestas propuestas={propuestas} />}
              </div>
              <div className="col-sm">
                <h3>Usuarios por Aprobar:</h3>
                {isBusy ? <Loading /> : <ListaUsuariosInactivos isBusy={isBusyTask} reFetch={reFetch} aprobar={aprobarUsuario} borrar={borrarUsuario} inactivos={inactivos} />}
              </div>
            </div>
          </Fragment>
        ) : (
            <Fragment>
              <div style={{ marginTop: 55 }} />
              <Login />
            </Fragment>
          )}
        <br />
        <br />
      </div>
      <Footer />
    </Fragment>
  );

  else return <Fragment>
    <WikiNavBar />
    <div style={{ marginTop: 55 }} />
    <div className="container">

      <h2>No Autorizado</h2>
      <p>No posees permisos para ingresar al Panel de Administración.</p>
    </div>
  </Fragment>
};

export default AdminPage;
